// @TODO: redevelop this component
// @flow
import React, {useState, useEffect, useRef} from "react";
import {useObserver} from "mobx-react-lite";
import {Col, Select, Spin, message, Checkbox, Button as AntButton} from "antd";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {SpaceField, CustomSelect, SelectTitle, SlotCourierTitle} from "./multipleSelectStyles";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {groupBy} from "lodash";
import {useTranslation} from "react-i18next";
import {projectInfoOptions} from "constants/constants";

const {Option, OptGroup} = Select;

/** Tek seçimli dropdown; eski çoklu değer (dizi) gelirse ilk elemanı kullanır */
const normalizeProjectInfo = value => {
    if (value == null || value === "") return undefined;
    if (Array.isArray(value)) return value.length ? value[0] : undefined;
    return value;
};

export const MultipleSelect = ({direction, list, data, onChange, disabled, hideTitle}) => {
    const stores = useStore();
    const {t} = useTranslation(["multipleSelect"]);

    const [cityValue, setCityValue] = useState(data?.city);
    const [companyValue, setCompanyValue] = useState(data?.dedicatedCompanyId || "");
    const [subCompanyValue, setSubCompanyValue] = useState(data?.dedicatedSubCompanies || ["all"]);
    const [slotCourierValue, setSlotCourierValue] = useState(data?.slotCourier);
    const [projectInfoValue, setProjectInfoValue] = useState(() =>
        normalizeProjectInfo(data?.projectInfo)
    );
    const [cityRecall, setCityRecall] = useState(false);
    const [companyRecall, setCompanyRecall] = useState(false);
    const [subCompanyRecall, setSubCompanyRecall] = useState(false);

    const [isCompanyChanged, setIsCompanyChanged] = useState(false);
    const [isSubCompanyChanged, setIsSubCompanyChanged] = useState(false);
    const [isSlotCourierChanged, setIsSlotCourierChanged] = useState(false);
    const [isProjectInfoChanged, setIsProjectInfoChanged] = useState(false);
    const cityRecallRef = useRef(cityRecall);
    const companyRecallRef = useRef(companyRecall);
    const subCompanyRecallRef = useRef(subCompanyRecall);

    cityRecallRef.current = cityRecall;
    companyRecallRef.current = companyRecall;
    subCompanyRecallRef.current = subCompanyRecall;

    useEffect(() => {
        setCityValue(data?.city);
        setCompanyValue(data?.dedicatedCompanyId || "");
        setSubCompanyValue(data?.dedicatedSubCompanies || ["all"]);
        setSlotCourierValue(data?.slotCourier);
        setProjectInfoValue(normalizeProjectInfo(data?.projectInfo));
        setIsCompanyChanged(false);
        setIsSubCompanyChanged(false);
        setIsSlotCourierChanged(false);
        setIsProjectInfoChanged(false);
        setSubCompanyRecall(prev => !prev);
    }, [
        data?.city,
        data?.dedicatedCompanyId,
        data?.dedicatedSubCompanies,
        data?.slotCourier,
        data?.projectInfo
    ]);

    const [cityLoading, cityData, setCityData, setCityLoading] =
        list.filter(obj => obj.key === "city").length > 0
            ? useFetch({
                  defaultDataValue: {},
                  fetchFn: stores.courierStore.getMultipleSelectCities.bind(null, {
                      limit: 1000,
                      offset: 0,
                      city: cityValue,
                      companyId: companyValue
                  }),
                  dependencies: [cityRecall]
              })
            : [false, [], () => {}, () => {}];

    const [companyLoading, companyData, setCompanyData, setCompanyLoading] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.courierStore.getMultipleSelectCompanies.bind(null, {
            limit: 1000,
            offset: 0,
            city: cityValue,
            companyId: companyValue
        }),
        dependencies: [companyRecall]
    });

    const [subCompanyLoading, subCompanyData, setSubCompanyData, setSubCompanyLoading] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.courierStore.getMultipleSelectSubCompanies.bind(null, {
            limit: 1000,
            offset: 0,
            city: data?.city,
            companyId: companyValue
        }),
        dependencies: [subCompanyRecall]
    });

    const onCityChange = value => {
        setCityValue(value);
    };

    const onCompanyChange = value => {
        companyValue !== value && setIsCompanyChanged(true);
        setCompanyValue(value);
        setSubCompanyValue(["all"]);
        setSubCompanyRecall(!subCompanyRecallRef.current);
    };

    const onSubCompanyChange = value => {
        subCompanyValue !== value && setIsSubCompanyChanged(true);
        if (value[value.length - 1] === "all") {
            setSubCompanyValue(["all"]);
        } else {
            const index = value.indexOf("all");
            index > -1 && value.splice(index, 1);
            setSubCompanyValue(value);
        }
    };

    const onProjectInfoChange = value => {
        setProjectInfoValue(value);
        setIsProjectInfoChanged(true);
    };

    useEffect(() => {
        if (
            [
                isSubCompanyChanged,
                isCompanyChanged,
                isSlotCourierChanged,
                isProjectInfoChanged
            ].some(i => i)
        ) {
            onChange({
                city: cityValue,
                companyId: companyValue,
                subCompanies: subCompanyValue,
                courierId: data?._id,
                slotCourier: slotCourierValue,
                projectInfo: projectInfoValue
            });
        }
    }, [cityValue, companyValue, subCompanyValue, slotCourierValue, projectInfoValue]);

    const filterSort = (optionA, optionB) =>
        optionA.children &&
        optionA.children
            .toString()
            .toLowerCase()
            .localeCompare(optionB.children.toString().toLowerCase());

    const filterOption = (input, option) =>
        option.children &&
        option.children
            .toString()
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0;

    const renderOptionLoading = key => (
        <Option key="loading" value="loading" data-testid={`${key}Select_option`}>
            <Spin size="small" spinning></Spin>
        </Option>
    );

    const renderAllOption = key => (
        <Option key="all" value="all" data-testid={`${key}Select_option`}>
            {t("filters.all", {ns: "common"})} {"                 "}
        </Option>
    );

    return useObserver(() => (
        <SpaceField direction={direction} style={{width: "100%"}}>
            {list.map((obj, i) => (
                <React.Fragment key={i}>
                    {obj.key === "city" && (
                        <Col>
                            {!hideTitle && (
                                <SelectTitle>{t("fields.city", {ns: "common"})}</SelectTitle>
                            )}
                            <CustomSelect
                                style={{width: obj.width}}
                                value={cityValue}
                                onChange={onCityChange}
                                notFoundContent={t("filters.notEnoughData", {ns: "common"})}
                                maxTagCount={2}
                                loading={cityLoading}
                                disabled={cityLoading || disabled}
                                data-testid={`${obj.key}Select`}
                            >
                                {cityLoading ? (
                                    renderOptionLoading(obj.key)
                                ) : (
                                    <Option>{data.city}</Option>
                                )}
                            </CustomSelect>
                        </Col>
                    )}
                    {obj.key == "company" && (
                        <Col>
                            {!hideTitle && (
                                <SelectTitle>{t("fields.company", {ns: "common"})}</SelectTitle>
                            )}
                            <CustomSelect
                                showSearch
                                style={{width: obj.width}}
                                value={companyValue}
                                onChange={onCompanyChange}
                                notFoundContent={t("filters.notEnoughData", {ns: "common"})}
                                loading={companyLoading}
                                disabled={companyLoading || disabled}
                                data-testid={`${obj.key}Select`}
                                optionFilterProp="children"
                            >
                                {companyLoading ? (
                                    renderOptionLoading(obj.key)
                                ) : (
                                    <>
                                        <CustomSelect.Option
                                            value=""
                                            data-testid={`${obj.key}Select_option`}
                                        >
                                            {t("poolCourier", {ns: "multipleSelect"})}
                                        </CustomSelect.Option>
                                        {stores.appStore.companyListFilter
                                            .filter(company => {
                                                if (companyValue === company?._id?.toString()) {
                                                    return true;
                                                }
                                                return company.disabled !== true;
                                            })
                                            .sort((a, b) =>
                                                a.companyName.localeCompare(b.companyName)
                                            )
                                            .map(company => (
                                                <CustomSelect.Option
                                                    disabled={company.disabled}
                                                    key={company._id}
                                                    value={company._id}
                                                    data-testid={`${obj.key}Select_option`}
                                                >
                                                    {company.companyName}
                                                </CustomSelect.Option>
                                            ))}
                                    </>
                                )}
                            </CustomSelect>
                        </Col>
                    )}
                    {obj.key === "subcompany" && (
                        <Col>
                            {!hideTitle && (
                                <SelectTitle>{t("fields.subcompany", {ns: "common"})}</SelectTitle>
                            )}
                            <CustomSelect
                                style={{width: obj.width}}
                                mode={"multiple"}
                                data-testid={`${obj.key}Select`}
                                value={
                                    subCompanyValue && subCompanyValue.length > 0
                                        ? subCompanyValue
                                        : ["all"]
                                }
                                onChange={onSubCompanyChange}
                                notFoundContent={t("filters.notEnoughData", {ns: "common"})}
                                loading={subCompanyLoading}
                                disabled={subCompanyLoading || disabled}
                                optionFilterProp="children"
                                filterOption={filterOption}
                                filterSort={filterSort}
                            >
                                {subCompanyLoading ? (
                                    renderOptionLoading(obj.key)
                                ) : (
                                    <>
                                        {renderAllOption(obj.key)}
                                        {subCompanyData?.rows?.length > 0 &&
                                            arrayAlphabeticalSort(subCompanyData?.rows)
                                                .filter(sub => {
                                                    if (
                                                        Array.isArray(subCompanyValue) &&
                                                        subCompanyValue.includes(
                                                            sub?._id?.toString()
                                                        )
                                                    ) {
                                                        return true;
                                                    }
                                                    return sub.disabled !== true;
                                                })
                                                .map(sub => (
                                                    <Option
                                                        key={sub._id}
                                                        value={sub._id}
                                                        data-testid={`${obj.key}Select_option`}
                                                    >
                                                        {sub.name}
                                                    </Option>
                                                ))}
                                    </>
                                )}
                            </CustomSelect>
                        </Col>
                    )}
                    {obj.key === "projectInfo" && (
                        <Col>
                            {!hideTitle && <SelectTitle>Proje Bilgisi</SelectTitle>}
                            <CustomSelect
                                allowClear
                                placeholder="Proje seçiniz"
                                value={projectInfoValue}
                                onChange={onProjectInfoChange}
                                disabled={disabled}
                                style={{width: obj.width}}
                                data-testid={`${obj.key}Select`}
                                optionFilterProp="children"
                            >
                                {projectInfoOptions?.map(option => (
                                    <CustomSelect.Option
                                        key={option.value}
                                        value={option.value}
                                        data-testid={`${obj.key}Select_option`}
                                    >
                                        {option.name}
                                    </CustomSelect.Option>
                                ))}
                            </CustomSelect>
                        </Col>
                    )}
                    {obj.key === "slotCourier" && (
                        <Col>
                            <Checkbox
                                checked={slotCourierValue}
                                data-testid={`${obj.key}CheckBox`}
                                disabled={disabled}
                                onChange={e => {
                                    setSlotCourierValue(e.target.checked);
                                    setIsSlotCourierChanged(true);
                                }}
                            />
                            <SlotCourierTitle style={{color: disabled ? "gray" : "black"}}>
                                {t("slotCourier", {ns: "multipleSelect"})}
                            </SlotCourierTitle>
                        </Col>
                    )}
                </React.Fragment>
            ))}
        </SpaceField>
    ));
};
